import { Autocomplete } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioAttoVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface AutocompleteListAttiProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  idDominio?: string;
  label?: string;
}

const AutocompleteListAttiComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  idDominio,
  label,
}: AutocompleteListAttiProps): React.ReactElement => {
  const [authorities, getAuthorities] = useHttpFetch<
    HttpResponse<Array<ValoreDominioAttoVO>>,
    Array<ItemVM>
  >(`${__ACT_API_URL__}/valori-dominio-atti/id-dominio/${idDominio}`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
    },
    transformer: (response) =>
      ((response.data.payload || []) as Array<ValoreDominioAttoVO>).map((item) => ({
        id: item.key?.idValore?.toString(),
        value: item.descrizioneBreveValore,
      })) as Array<ItemVM>,
  });

  const authoritiesData: Array<ItemVM> = useMemo(() => {
    return (authorities?.data || []) as Array<ItemVM>;
  }, [authorities?.data]);

  const defaultProps = useMemo(() => {
    return {
      options: (authorities.data as Array<ItemVM>) || [],
      getOptionLabel: (option: ItemVM) => option.value,
    };
  }, [authorities.data]);

  const selectedValue = defaultProps.options.find((elem) => elem.id === value);

  useEffect(() => {
    if (!idDominio) {
      return;
    }
    getAuthorities();
  }, [idDominio]);

  // const handleSearch = debounce<string>(
  //   useCallback(
  //     (searchValue) => {
  //       if (authorities.abort) {
  //         authorities.abort();
  //       }

  //       const transformedFilters: OperationObject = {
  //         dsValoreBreve: { value: searchValue || '', operation: Operation.LIKE },
  //       };

  //       const queryString = `${paginationListToQueryString({
  //         filters: transformedFilters,
  //         orders: {},
  //       })}`;

  //       getAuthorities({
  //         params: {},
  //         paramsSerializer: () => queryString,
  //       });
  //     },
  //     [getAuthorities, authorities.abort]
  //   )
  // );

  return (
    <Autocomplete
      {...defaultProps}
      id={`${label}-id`}
      value={{ id: selectedValue?.id || '', value: selectedValue?.value || '' }}
      noOptionsText="Nessun elemento"
      loadingText="Caricamento..."
      onChange={(event, element) => {
        event.stopPropagation();
        onChange(authoritiesData.find((item) => item.id === element?.id));
      }}
      disabled={disabled}
      // onInputChange={(event, changeValue, reason) => {
      //   if (Boolean(changeValue) && changeValue.length >= 3 && reason === 'input') {
      //     handleSearch(changeValue);
      //   }
      // }}
      clearOnBlur={false}
      loading={authorities.isLoading}
      renderInput={(params) => (
        <PmiTextField
          {...params}
          label={required ? `${label} *` : label}
          variant="outlined"
          error={error}
        />
      )}
    />
  );
};

AutocompleteListAttiComponent.displayName = 'Autocomplete list atti component';

const AutocompleteListAtti = memo(AutocompleteListAttiComponent);

export default AutocompleteListAtti as typeof AutocompleteListAttiComponent;
